import { render, staticRenderFns } from "./distributionAssistant.vue?vue&type=template&id=057dd516&scoped=true&"
import script from "./distributionAssistant.vue?vue&type=script&lang=js&"
export * from "./distributionAssistant.vue?vue&type=script&lang=js&"
import style0 from "./distributionAssistant.vue?vue&type=style&index=0&id=057dd516&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "057dd516",
  null
  
)

export default component.exports